import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthPage } from './components/auth/AuthPage';
import { VerifyEmail } from './components/auth/VerifyEmail';
import { ResetPassword } from './components/auth/ResetPassword';
import { OrganizationSetup } from './components/organization/OrganizationSetup';
import { InviteAcceptance } from './components/organization/InviteAcceptance';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { TodoApp } from './components/TodoApp';
import Settings from './components/Settings';
import AIAssistant from './components/AIAssistant';
import LandingPage from './components/LandingPage';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Landing Page - główna strona */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Public routes dla aplikacji */}
          <Route path="/app/login" element={<AuthPage />} />
          <Route path="/app/verify-email" element={<VerifyEmail />} />
          <Route path="/app/reset-password" element={<ResetPassword />} />
          <Route path="/app/invite" element={<InviteAcceptance />} />
          
          {/* Protected routes dla aplikacji */}
          <Route 
            path="/app/setup-organization" 
            element={
              <ProtectedRoute>
                <OrganizationSetup />
              </ProtectedRoute>
            } 
          />
          
          {/* Settings page - requires authentication and organization */}
          <Route 
            path="/app/settings" 
            element={
              <ProtectedRoute requireOrganization={true}>
                <Settings />
              </ProtectedRoute>
            } 
          />
          
          {/* Main todo app - requires authentication and organization */}
          <Route 
            path="/app" 
            element={
              <ProtectedRoute requireOrganization={true}>
                <TodoApp />
              </ProtectedRoute>
            } 
          />
          
          {/* AI Assistant - requires authentication, organization and AI access */}
          <Route 
            path="/app/ai-assistant" 
            element={
              <ProtectedRoute requireOrganization={true} requireAIAccess={true}>
                <AIAssistant />
              </ProtectedRoute>
            } 
          />
          
          {/* Redirect old routes to new structure */}
          <Route path="/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/verify-email" element={<Navigate to="/app/verify-email" replace />} />
          <Route path="/reset-password" element={<Navigate to="/app/reset-password" replace />} />
          <Route path="/invite" element={<Navigate to="/app/invite" replace />} />
          <Route path="/setup-organization" element={<Navigate to="/app/setup-organization" replace />} />
          <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
          
          {/* Catch all route - redirect to landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App; 